import { isTypeObject as e } from "./helpers/is-type-object.js";
import { useLocalization as t } from "./localization/index.js";
import { Fragment as n, computed as r, createBlock as i, createCommentVNode as a, createElementBlock as o, createElementVNode as s, createTextVNode as c, defineComponent as l, openBlock as u, toDisplayString as d, unref as f } from "vue";
import { ScalarWrappingText as p } from "@scalar/components/wrapping-text";
import { isArraySchema as m } from "@scalar/workspace-store/schemas/v3.2/strict/type-guards";
//#region src/schema/SchemaHeading.vue?vue&type=script&setup=true&lang.ts
var h = {
	key: 0,
	class: "schema-type"
}, g = ["title"], _ = /*@__PURE__*/ l({
	__name: "SchemaHeading",
	props: {
		value: {},
		name: {}
	},
	setup(l) {
		let { translate: _ } = t(), v = r(() => "type" in l.value ? l.value.type : l.value.enum ? "enum" : m(l.value) && l.value.items ? "array" : e(l.value) && (l.value.properties || l.value.additionalProperties) ? "object" : "unknown");
		return (t, r) => typeof l.value == "object" ? (u(), o("span", h, [s("span", {
			class: "schema-type-icon",
			title: "type" in l.value && typeof l.value.type == "string" ? l.value.type : "type" in l.value && Array.isArray(l.value.type) ? l.value.type.join(" | ") : f(_)("schema.unknownType")
		}, [
			f(e)(l.value) ? (u(), o(n, { key: 0 }, [c(" {} ")], 64)) : a("", !0),
			f(m)(l.value) ? (u(), o(n, { key: 1 }, [c(" [] ")], 64)) : a("", !0),
			l.value.enum ? (u(), o(n, { key: 2 }, [c(" enum ")], 64)) : a("", !0)
		], 8, g), l.name ? (u(), i(f(p), {
			key: 0,
			preset: "property",
			text: l.name
		}, null, 8, ["text"])) : (u(), o(n, { key: 1 }, [c(d(v.value), 1)], 64))])) : a("", !0);
	}
});
//#endregion
export { _ as default };

//# sourceMappingURL=SchemaHeading.vue_vue_type_script_setup_true_lang.js.map